import { adminHttpClient } from '../../../commons/adminHttpClient'
import { Moment } from 'moment'

export interface ForCompleteCompanyDetailsForm {
  availableStates: AvailableState[]
  name: string
  ein: string
  taxClassification: string
  addressLine1: string
  addressLine2: string | null
  city: string
  stateId: string
  zipCode: string
  mainPhoneNumber: string
  groupHealthPlan: GroupHealthPlan
}

interface GroupHealthPlan {
  startDate: Moment
  insuranceCarrier: string
  insurancePlan: string
}

export type AvailableState = {
  id: string
  name: string
}

const getForCompleteCompanyDetailsForm = (): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/CompanySettings/CompanyDetails/ForSave')
}

export default getForCompleteCompanyDetailsForm
